import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close-icon",
  "use": "close-icon-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 17\" id=\"close-icon\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.757.462c.47.47.47 1.23 0 1.7L2.161 15.758a1.202 1.202 0 0 1-1.7-1.7L14.058.463c.47-.469 1.23-.469 1.7 0Z\" fill=\"currentColor\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M.461.462c.47-.469 1.23-.469 1.7 0L15.757 14.06a1.202 1.202 0 0 1-1.7 1.7L.462 2.161c-.469-.47-.469-1.23 0-1.7Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol